import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import PrimaryTabPanel from "../TabPanels/PrimaryTabPanel/PrimaryTabPanel";
import PrimaryTabs from "../TabPanels/PrimaryTabPanel/PrimaryTabs/PrimaryTabs";
import UserProfile from "../UserProfile/UserProfile";
import UserManagement from "../UserManagement/UserManagement";
import Regions from "../Regions/Regions";
import UserProfileOverlay from "../UserProfileOverlay/UserProfileOverlay";
import SecurityCheck from "../SecurityCheck/SecurityCheck";
import { ActiveUserContext } from "../Dashboard/Dashboard";

export default function Admin() {
  let navigate = useNavigate();
  let location = useLocation();
  const activeUser = useContext(ActiveUserContext);
  const [tabValue, setTabValue] = useState(0);
  const [userUpdated, setUserUpdated] = useState({});
  const [isAdminUser, setIsAdminUser] = useState(true);
  const basePath = "/dashboard/admin/";
  const path = location.pathname;

  const tabs = [
    {
      name: "My Account",
      path: "my-account",
    },
    {
      name: isAdminUser ? "User Management" : "",
      path: "user-management",
      disabled: !isAdminUser
    },
    {
      name: "Region Management",
      path: "region-management"
    }
  ];

  const handleTabChange = (event, newValue) => {
    const newPath = tabs[newValue].path;
    navigate(newPath);
  };

  useEffect(() => {
    const tabIndex = tabs.findIndex(i => basePath + i.path === path);

    if (tabIndex >= 0) {
      setTabValue(tabIndex);
    }
  }, [path]);

  return (
    <Box sx={{ paddingTop: "30px" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", margin: "0 30px 10px 30px" }}>
        <PrimaryTabs value={tabValue} handleChange={handleTabChange} tabLabels={tabs} />
      </Box>
      <PrimaryTabPanel value={tabValue} index={0}>
        <UserProfile
          userId={activeUser?.userId}
          handleUserUpdated={setUserUpdated}
        />
      </PrimaryTabPanel>
      <SecurityCheck
        componentName="Admin"
        action="Read"
        callbackRequired={true}
        callback={setIsAdminUser}
      >
        <PrimaryTabPanel value={tabValue} index={1}>
          <UserManagement userUpdated={userUpdated} />
        </PrimaryTabPanel>
      </SecurityCheck>
      <PrimaryTabPanel value={tabValue} index={2}>
        <Regions />
      </PrimaryTabPanel>
      <Routes>
        <Route path="/" element={
          <></>
        }>
        </Route>
        <Route
          path="/user-management/user-profile"
          element={
            <UserProfileOverlay
              handleUserUpdated={setUserUpdated}
            />
          }
        />
      </Routes>
    </Box>
  );
}

Admin.propTypes = {};